import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  const navigate = useNavigate();

  const handleSignup = () => {
    navigate('/authentication-hub');
  };

  const handleDemo = () => {
    const featuresSection = document.getElementById('features');
    if (featuresSection) {
      featuresSection?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 pt-32 pb-20 px-6 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full">
              <Icon name="Sparkles" size={16} color="var(--color-primary)" />
              <span className="text-sm font-medium text-primary">
                Plataforma completa para psicólogos
              </span>
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold text-foreground leading-tight">
              Simplifique sua prática {' '}
              <span className="text-primary">clínica</span>
            </h1>

            <p className="text-xl text-muted-foreground leading-relaxed">
              Gerencie pacientes, agendamentos e comunicações em uma única plataforma intuitiva. Automatize lembretes via WhatsApp e foque no que realmente importa: seus atendimentos.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                onClick={handleSignup}
                iconName="ArrowRight"
                iconPosition="right"
                className="shadow-lg hover:shadow-xl transition-shadow">

                Começar Gratuitamente
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={handleDemo}
                iconName="Play"
                iconPosition="left">

                Ver Demonstração
              </Button>
            </div>

            <div className="flex items-center gap-8 pt-4">
              <div className="flex items-center gap-2">
                <Icon name="Check" size={20} color="var(--color-success)" />
                <span className="text-sm text-muted-foreground">
                  Sem cartão de crédito
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Check" size={20} color="var(--color-success)" />
                <span className="text-sm text-muted-foreground">
                  Configuração em 5 minutos
                </span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-accent/20 rounded-3xl blur-2xl"></div>
            <div className="relative bg-white rounded-2xl shadow-2xl p-8 border border-border">
              <Image
                src={`${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/public-images/paciente0.png`}
                alt="Professional female psychologist with warm smile wearing white coat in modern clinic office with natural lighting and plants in background"
                className="w-full h-auto rounded-xl" />

              <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-4 border border-border">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-success/10 rounded-full flex items-center justify-center">
                    <Icon name="Calendar" size={24} color="var(--color-success)" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground">
                      +250 Consultas
                    </p>
                    <p className="text-xs text-muted-foreground">
                      Agendadas este mês
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;